module.exports = __webpack_public_path__ + "img/viber_back_2.765def13.png";